import React, { useEffect, useState } from 'react';
import { useSearchBox } from '../../contexts/SearchBoxContext';
import useTypingAnimation from '../../tools/hookTypingAnimation';
import { dynamicClassName } from '../../tools/tools';
import FloatingSearchBarInput from './FloatingSearchBarInput';

const pathToExclude = '/engine/';
const TYPING_SPEED = 150;
const PAUSE_TIME = 1000;
const NAV_BAR_HEIGHT = 71;

interface FloatingSearchBarProps {
  placeholderSentences?: string[];
}

const FloatingSearchBar: React.FC<FloatingSearchBarProps> = ({ placeholderSentences }) => {
  const [isFocus, setIsFocus] = useState<boolean>(false);
  const [scrollY, setScrollY] = useState<number>(0);
  const [input, setInput] = useState<string>('');
  const [path, setPath] = useState<string>('');

  const { searchBoxPosition } = useSearchBox();
  const [query] = React.useState('');
  const [isSearchBarVisible, setIsSearchBarVisible] = useState<boolean>(false);

  const shouldDisplayBar = (path: string, scrollY: number, searchBoxPosition: number): void => {
    if (path === '' || path.includes(pathToExclude)) {
      setIsSearchBarVisible(false);
    } else {
      setIsSearchBarVisible(scrollY > searchBoxPosition - NAV_BAR_HEIGHT);
    }
  };

  const onInputChange = (e: string): void => setInput(e);

  useEffect(() => {
    setPath(window?.location?.pathname);
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setPath(window.location.pathname);
      const onScroll = () => {
        if (window.scrollY !== scrollY) {
          setScrollY(window.scrollY);
        }
        shouldDisplayBar(path, window.scrollY, searchBoxPosition.bottomPosition);
      };
      window.addEventListener('scroll', onScroll);
      return () => {
        window.removeEventListener('scroll', onScroll);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollY, searchBoxPosition.bottomPosition]);

  const currentText = useTypingAnimation({ placeholderSentences, TYPING_SPEED, PAUSE_TIME, query });

  if (isSearchBarVisible) {
    return (
      <div className={dynamicClassName('floatingSearchBar-modal', isFocus)}>
        <FloatingSearchBarInput
          onInputChange={onInputChange}
          placeholder={currentText}
          input={input}
          isFocus={isFocus}
          onFocus={setIsFocus}
        />
      </div>
    );
  }
  return null;
};

export default FloatingSearchBar;
